import React, { useState, useEffect } from 'react';
import { useLocalStorage, useDebounce } from 'react-use';
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Table,
} from 'react-bootstrap';
import FileUpload from 'components/FileUpload/FileUpload.js';
import useNotif from 'hooks/use-notify-hook';
import AnswerRepository from 'repository/Answer.js';
import moment from 'moment';

function Input({ answer, isReadonly }) {

  const [auth] = useLocalStorage('authenticated');
  const [notif, dispatchNotif] = useNotif();
  const [input, setInput] = useState(answer.ANSWER_DESC ?? '');
  const [explanation , setExplanation] = useState(answer.ADD_EXPLAN ?? '');
  // const [evaluation, setEvaluation] = useState(answer?.EVALUATE_DESC ?? ``);
  const [attachments, setAttachments] = useState(answer?.answerAttachments ?? []);

  const repository = new AnswerRepository(auth.token);

  let filePromises = [];

  const handleUpload = async (file) => {

    try {

      filePromises.push(repository.upload(answer.ANSWER_ID, file));

      const promises = await Promise.all(filePromises);
      //setAttachments([...attachments, ...promises.map(item => item.data)]);
      promises.map(item => attachments.push(item.data));
      dispatchNotif({
        place: `br`,
        message: `Upload Success...`,
        type: `success`,
      });

      filePromises = [];

    } catch(ex) {

      dispatchNotif({
        place: `br`,
        message: `Upload Failed ${ex.toString()}`,
        type: `danger`,
      });

    }
  }

  const handleDeleteAttachment = async(attachmentId) => {

    try{

      const response = await repository.deleteAttachment(attachmentId);

      dispatchNotif({
        place: `br`,
        message: `Delete Success...`,
        type: `success`,
      });

      var data =  attachments.filter(attachment => attachment.ATTACHMENT_ID != attachmentId);

      setAttachments(data);

    }catch(ex){

      dispatchNotif({
        place: `br`,
        message: `Failed ${ex.toString()}`,
        type: `danger`,
      });

    }
  }


  const [, cancelInput] = useDebounce(async () => {

    try {

      const data = {
        ANSWER_AT: moment().format('DD-MM-YYYY hh:mm:ss'),
        ANSWER_BY: auth.employee.EMP_ID,
        ANSWER_DESC: input,
        ADD_EXPLAN: explanation,

      };

      const response = await repository.answer(answer.ANSWER_ID, data);

      dispatchNotif({
        place: `br`,
        message: `Update Success...`,
        type: `success`,
      });

    }catch(ex){
      dispatchNotif({
        place: `br`,
        message: `Failed: ${ex.toString()}`,
        type: `danger`,
      });
    }


  }, 2000, [input]);

  useEffect(() => {

    cancelInput();

  }, []);

  return (
    <Row>
      {notif}
      <Col md="12">
        <Card>
          <Card.Header>
          <Card.Title style={{fontWeight:'bold', fontSize:'20px', marginBottom:10}} as="h5">{answer.question.QUESTION_CODE}. <a style={{fontWeight:'bold'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_LABEL}} /></Card.Title>
            <div style={{whiteSpace: 'pre-wrap', marginLeft:18, marginTop:5, fontSize:'17px'}} dangerouslySetInnerHTML={{__html: answer.question.QUESTION_DESC}} />
            <hr></hr>
          </Card.Header>
          <Card.Body>
            <Row>
              <Col md="8">
                <Form.Group>
                  <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Answer</Form.Label>
                  {isReadonly
                    ? <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: input}} />
                    : (
                      <>
                        <Form.Control
                          value={input}
                          onChange={({ target: { value } }) => setInput(value)}
                          as="textarea"
                          rows={3}
                          disabled={isReadonly}
                          isInvalid={input?.length > 4000}
                        />
                        <Form.Text id="passwordHelpBlock" muted>
                          Total characters: {input?.length ?? 0} / 4000
                        </Form.Text>
                      </>
                    )
                  }
                </Form.Group>
                <Form.Group>
                  <Form.Label style={{fontSize: '15px',fontWeight: '600',color: '#333'}}>Evaluation</Form.Label>
                  <div style={{whiteSpace: 'pre-wrap'}} dangerouslySetInnerHTML={{__html: answer.EVALUATE_DESC}} />
                </Form.Group>
              </Col>
              <Col md="4">
                <Form.Group>
                  <Form.Label style={{fontSize:'17px'}}>Attachment(s)</Form.Label>
                  {attachments && attachments.length > 0
                    ? (
                      <span className="form-control"
                        style={{
                          maxHeight: `200px`,
                          height: `200px`,
                          overflowY: `scroll`,
                          marginBottom: `10px`
                        }}
                      >
                        {attachments.map((attachment, key) => (
                          <div key={key} className="font-icon-detail">
                            <i className="nc-icon nc-attach-87"></i>{' '}
                            <a href={`${process.env.REACT_APP_API_HOST}answer-attachments/${attachment.ATTACHMENT_ID}/download`} target="_blank">
                              {attachment.ATTACHMENT_NAME}.{attachment.ATTACHMENT_EXT}
                            </a>{' '}
                            {!isReadonly && (
                              <button className="btn btn-danger nc-icon nc-simple-remove" value={attachment.ATTACHMENT_ID} onClick={() => handleDeleteAttachment(attachment.ATTACHMENT_ID)}></button>
                            )}
                          </div>
                        ))}
                      </span>
                    )
                    : <p>No file uploaded.</p>
                  }
                  {!isReadonly && (
                    <FileUpload
                      disabled={isReadonly}
                      onFileSelectSuccess={(file) => handleUpload(file)}
                      onFileSelectError={({ error }) => alert(error)}
                    >
                      Upload
                    </FileUpload>
                  )}
                </Form.Group>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}


export default React.memo(Input, (prev, next) => {
  if (prev.answer.ANSWER_DESC === next.answer.ANSWER_DESC) return true;
});